import React from "react";
import { Typography, useTheme } from "@mui/material";
import FloodIcon from "@mui/icons-material/Flood";
import HouseIcon from "@mui/icons-material/House";
import AirIcon from "@mui/icons-material/Air";
import DashboardInfoItem from "../../../shared/components/dashboard/DashboardInfoItem";
import { FlexContainer } from "../../../shared/components/styled/Container.styled";
import { NOT_APPLICABLE } from "../../../shared/constants/Defaults.constants";
import { hex2rgba } from "../../../shared/utils/utility-functions";

const TaxInsuranceDetails = ({
  realEstateCurrent = NOT_APPLICABLE,
  hazardCurrent = NOT_APPLICABLE,
  insuranceDetails = [],
  showTaxes = true,
  showInsurance = true,
}) => {
  const theme = useTheme();

  const getInsuranceIcon = (type) => {
    switch (type.toLowerCase()) {
      case "hazard":
        return <HouseIcon color="primary" sx={{ fontSize: "64px" }} />;
      case "flood":
        return <FloodIcon color="primary" sx={{ fontSize: "64px" }} />;
      case "wind":
        return <AirIcon color="primary" sx={{ fontSize: "64px" }} />;
      default:
        return <HouseIcon color="primary" sx={{ fontSize: "64px" }} />;
    }
  };

  const formatCurrency = (amount) => {
    return amount
      ? `$${amount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : NOT_APPLICABLE;
  };

  return (
    <FlexContainer gap="25px" flexwrap="wrap" sx={{
      width: {
        xs: '100%',
        md: '70%'
      },
      padding: {
        xs: '0',
        md: "0 0 0 50px"
      }
    }}>
      {/* Real Estate Taxes */}
      {showTaxes ? (
        <FlexContainer
          flexdirection="row"
          alignitems="flex-start"
          gap="10px"
          background={hex2rgba(theme.palette.primary.main, 0.1)}
          padding="25px"
          sx={{
            flex: "1",
          }}
        >
          <HouseIcon color="primary" sx={{ fontSize: "64px" }} />
          <FlexContainer flexdirection="column" alignitems="flex-start">
            <Typography fontWeight="bold">Real Estate Taxes</Typography>
            <FlexContainer gap="50px">
              <DashboardInfoItem
                label="Current Year"
                data={realEstateCurrent}
                prefix={realEstateCurrent === NOT_APPLICABLE ? "" : "$"}
              />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      ) : null}

      {/* Insurance Details */}
      {showInsurance &&
        insuranceDetails.map((insurance, index) => (
        <FlexContainer
          key={index}
          flexdirection="row"
          alignitems="flex-start"
          gap="10px"
          background={hex2rgba(theme.palette.primary.main, 0.1)}
          padding="25px"
          sx={{
            flex: '1',
          }}
        >
          {getInsuranceIcon(insurance.type)}
          <FlexContainer flexdirection="column" alignitems="flex-start">
            <Typography fontWeight="bold">
              {insurance.type} Insurance
            </Typography>
            <FlexContainer gap="50px">
              <DashboardInfoItem
                label="Policy Premium"
                data={formatCurrency(insurance.amount)}
                prefix=""
              />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      ))}
    </FlexContainer>
  );
};

export default TaxInsuranceDetails;